<template>
  <UserLayout>
    <section class="md:mt-36 mt-28 md:px-10 md:ml-20">
      <!-- <TipPaymentModal
        v-if="session && session.details"
        :details="session && session.details"
      ></TipPaymentModal> -->
      <LoginSessionModal
        :isLoginSessionModalOpen="isLoginSessionModalOpen"
        :handleLoginSessionModal="handleLoginSessionModal"
        :handleLoginSuccess="handleLoginSuccess"
      />
      <section v-if="isSessionJoinModalOpen">
        <SessionJoinModal
          :showCancelButton="false"
          :isSessionJoinModalOpen="isSessionJoinModalOpen"
          :handleSessionJoinModal="handleSessionJoinModal"
          :session_thumbnail_url="baseUrlSrc(batch.thumbnail_url)"
          :sessionTitle="batch.title"
          :sessionDate="handleMonthDateTime(batch.start_date)"
          :sessionTime="
            handleHour12(batch.start_date) +
            ' - ' +
            handleHour12(batch.end_date)
          "
          :sessionCost="batch.cost"
          :wallet_balance="wallet_balance"
          :handleJoinClick="handleJoinClick"
          :handleAddMoney="handleButtonClick"
        />
      </section>

      <section>
        <!-- <Jitsi
          v-if="batch && batch.start_date"
          :role="ROLE"
          :batchId="batch && batch.id"
          :startDate="batch && batch.start_date"
          :thumbnailUrl="batch && batch.thumbnail_url"
          :data="users_joined"
          :participantLimit="batch && batch.total_webcam_allowed"
          :sessionEnded="sessionEndedThumbnailImage"
          :handleLoginSuccess="handleLoginSuccess"
        /> -->
        <img
          :src="batch && batch.thumbnail_url"
          class="object-cover max-w-3xl absolute top-0 mt-24 rounded-lg"
          alt=""
        />
      </section>

      <div class="w-full max-w-7xl mx-auto mt-96">
        <div class="py-2 w-full max-w-3xl">
          <section class="md:flex justify-between items-center mt-36">
            <div>
              <h3 class="uppercase mt-4 text-xl font-bold">
                {{ batch && batch.title }}
              </h3>
              <p class="captitalize text-gray-dark">
                {{ batch && batch.category }}
              </p>
            </div>
            <div>
              <!-- @click="trainerModalOpen" -->
              <!-- v-if="paymentEnableDisable == 1 && user && user.user_type == 1" -->
              <button
                type="button"
                class="h-8 px-3 m-2 text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
                id="tip-trainer"
                @click="getSignature"
                v-if="meeting && meeting.meeting_link"
              >
                <!-- Tip Trainer -->
                Start Class
              </button>
              <!-- <button
                type="button"
                id="tip-trainer"
                class="h-8 px-3 m-2 text-white transition-colors duration-150 bg-green-light opacity-50 rounded-lg focus:outline-none hidden cursor-not-allowed"
                v-else-if="!paymentEnableDisable"
              >
                Tip Trainer
              </button> -->
              <!-- <button
                type="button"
                id="tip-trainer"
                class="h-8 px-3 m-2 text-white transition-colors duration-150 bg-green-light opacity-50 rounded-lg focus:outline-none hidden cursor-not-allowed"
                v-else-if="
                  paymentEnableDisable == 1 && user && user.user_type == 0
                "
              >
                Tip Trainer
              </button> -->
              <!-- modal for room size full  -->
              <Modal
                :title="'Room size is full'"
                v-model="roomSizeFull"
                :hideModalHeader="true"
              >
                <div class="flex justify-center">
                  <img
                    :src="require(`@/assets/svg/guest-modal-pop-up.svg`)"
                    alt="guest-modal-pop-up.svg"
                  />
                </div>
                <div class="flex justify-center mt-12 text-2xl">
                  <h1>Room size is full.</h1>
                </div>
                <div class="flex justify-center mt-8 text-xl">
                  <router-link
                    :to="{
                      name: 'DashboardBeforeLogin',
                    }"
                  >
                    <div class="bg-green-light px-3 py-2 rounded-lg">
                      <p class="text-white">Go to home</p>
                    </div>
                  </router-link>
                </div>
              </Modal>
              <!-- modal for session completed and rating and reviews  -->
              <Modal
                :title="'Feedback for ' + batch.title"
                :whiteCross="'text-white'"
                v-model="sessionEnded"
              >
                <!--
                <div class="p-6">
                  <div class="flex justify-center">
                    <img
                      :src="require(`@/assets/svg/guest-modal-pop-up.svg`)"
                      alt="guest-modal-pop-up.svg"
                    />
                  </div>
                  <div class="flex justify-center mt-12 text-2xl">
                    <h1>The Class is completed</h1>
                  </div>
                  <div class="flex justify-center mt-8 text-xl">
                    <div
                      @click="sessionEnded = !sessionEnded"
                      class="cursor-pointer rounded-lg mr-8 px-6 pt-2 pb-1 ring-green-light ring-1 text-green-light"
                    >
                      <p>Return</p>
                    </div>

                    <router-link
                      :to="{
                        name: 'DashboardBeforeLogin',
                      }"
                    >
                      <div class="bg-green-light px-3 py-2 rounded-lg">
                        <p class="text-white">Go to home</p>
                      </div>
                    </router-link>
                  </div>
                </div>
                -->
                <SessionReviewPost
                  v-if="user && user.user_type != 0"
                  :data="batch"
                  callerComp="sessionModal"
                  v-on:hidePostReview="sessionEnded = false"
                />
              </Modal>
              <Modal :title="'Tip Trainer'" v-model="isModalOpen">
                <form
                  class="space-y-4 text-gray-dark"
                  @submit.prevent="tipTrainerSubmit"
                >
                  <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
                    <div class="w-full px-2 md:w-1/2">
                      <label class="block mb-1" for="">Name</label>
                      <input
                        class="w-full h-10 px-3 text-base placeholder-gray-light ring-1 ring-gray-300 rounded-lg focus:shadow-outline"
                        type="text"
                        :value="getUser() && getUser().name"
                        disabled
                      />
                    </div>
                    <div class="w-full px-2 md:w-1/2">
                      <label class="block mb-1" for="">Credits</label>
                      <input
                        class="w-full h-10 px-3 text-base placeholder-gray-light ring-1 ring-gray-300 rounded-lg focus:shadow-outline"
                        type="text"
                        placeholder="Enter amount here"
                        v-model="$v.credits.$model"
                        :class="{ 'border-red-500': $v.credits.$error }"
                      />
                      <div v-if="$v.credits.$error">
                        <small class="text-red-500" v-if="!$v.credits.required">
                          Credits field is required.
                        </small>
                        <small class="text-red-500" v-if="!$v.credits.numeric">
                          Accepts only numerics.
                        </small>
                        <small class="text-red-500" v-if="creditsGreaterOrLess">
                          Please add more money to wallet.
                        </small>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-wrap">
                    <div class="w-full">
                      <label class="block mb-1" for="formGridCode_card"
                        >Message</label
                      >
                      <textarea
                        class="w-full h-16 px-3 py-2 text-base text-gray-dark placeholder-gray-600 ring-1 ring-gray-300 rounded-lg focus:shadow-outline"
                        placeholder="Enter message here. (250 char)"
                        v-model="$v.message.$model"
                        :class="{ 'border-red-500': $v.message.$error }"
                      ></textarea>
                      <div v-if="$v.message.$error">
                        <small class="text-red-500" v-if="!$v.message.required">
                          Message field is required.
                        </small>
                      </div>
                    </div>
                  </div>
                  <div class="float-right">
                    <button
                      type="button"
                      class="h-8 px-3 m-2 text-green-light transition-colors duration-150 rounded focus:shadow-outline"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      class="h-8 px-3 m-2 text-white transition-colors duration-150 bg-green-light rounded focus:shadow-outline hover:bg-green-light"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </Modal>
            </div>
          </section>
          <section>
            <h5 class="capitalize mt-4 text-lg font-bold">Description</h5>
            <p class="text-gray-800 text-sm">
              {{ batch && batch.description }}
            </p>
          </section>
          <hr class="mt-4" />
          <section v-if="stores && stores.length != 0">
            <h5 class="capitalize mt-4 text-lg font-bold">Merchandise</h5>
            <section>
              <MerchandiseCardList :data="stores" />
            </section>
          </section>
          <section>
            <div class="flex justify-between items-center">
              <h5 class="capitalize mt-4 text-lg font-bold">Reviews</h5>
              <button
                v-if="sessionReviewBatch && sessionReviewBatch.data"
                type="button"
                class="inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                @click="toggleSessionReview"
              >
                See All
              </button>
            </div>

            <section v-if="sessionStarted">
              <SessionReviewPost
                v-if="isSessionReviewBatchShow && user && user.user_type != 0"
                :data="batch"
                v-on:hidePostReview="isSessionReviewBatchShow = false"
              />
            </section>
          </section>
          <section>
            <div class="py-4">
              <SessionReviewList
                v-on:review_id="handleReviewId"
                :data="
                  sessionReviewBatch &&
                  sessionReviewBatch.data &&
                  sessionReviewBatch.data.slice(0, 4)
                "
                @SessionReviewDeleted="reviewDeleted()"
                @EditReview="handleEditReview"
              />
              <SessionReviewPost
                v-if="showEditReview"
                :data="batch"
                :editReview="showEditReview"
                :review_id="review_id"
                v-on:hidePostReview="showEditReview = false"
              />
            </div>
            <div v-if="sessionFeedbackAll">
              <SessionFeedbackAll
                :data="sessionReviewBatch && sessionReviewBatch.data"
                :sessionFeedbackAll="sessionFeedbackAll"
                :handleSessionFeedbackAllModal="handleSessionFeedbackAllModal"
              />
            </div>
          </section>
        </div>
      </div>
    </section>
  </UserLayout>
</template>

<script>
import UserLayout from "@/components/layouts/UserLayout";
import { Modal } from "@/components/t-components";
import MerchandiseCardList from "@/components/MerchandiseCardList";
import SessionReviewList from "@/components/SessionReviewList";
import SessionReviewPost from "@/components/SessionReviewPost";
import { mapActions, mapGetters } from "vuex";
import { numeric, required } from "vuelidate/lib/validators";
import SessionFeedbackAll from "@/components/user/SessionFeedbackAll.vue";
import LoginSessionModal from "@/components/LoginSessionModal";
import SessionJoinModal from "@/components/SessionJoinModal.vue";
import * as Cookies from "js-cookie";
import Vue from "vue";
import axios from "axios";
import { ZoomMtg } from "@zoomus/websdk";
import TipPaymentModal from "@/components/t-components/TipPaymentModal";
import "@/assets/css/bootstrap.css";

export default {
  components: {
    UserLayout,
    Modal,
    MerchandiseCardList,
    SessionReviewList,
    SessionReviewPost,
    // Jitsi,
    SessionFeedbackAll,
    LoginSessionModal,
    SessionJoinModal,
    TipPaymentModal,
  },
  data() {
    return {
      showModal: false,
      isSessionReviewBatchShow: true,
      batch: [],
      meeting: [],
      reviews: [],
      stores: [],
      users_joined: [],
      ROLE: 2, // 1 for host 2 for participant
      REVIEW_TYPE: 2, // for session/course batch
      IS_LIKED: 1, // 0 for increase or 1 for decrease
      isModalOpen: false,
      credits: "",
      message: "",
      showEditReview: false,
      review_id: 0,
      sessionFeedbackAll: false,
      creditsGreaterOrLess: false,
      user: JSON.parse(localStorage.getItem("user")),
      isLoginSessionModalOpen: false,
      interval: 0,
      isSessionJoinModalOpen: false,
      wallet_balance: "",
      batches: {},
      session: {},
      sessionJoinData: {},
      sessionEnded: false,
      sessionEndedThumbnailImage: false,
      roomSizeFull: false,
      sessionStarted: false,
      paymentEnableDisable: "",
      sdkKey: "JN61VXxPXfzVSUo8dSeFa2yTUBkCywpvmO2I",
      leaveUrl: window.location.href,
      signatureEndpoint: "https://cable.fitclass.com",
      userEmail: this.getUser().email,
    };
  },
  validations: {
    credits: {
      required,
      numeric,
    },
    message: {
      required,
    },
  },
  computed: {
    ...mapGetters([
      "sessionReviewBatch",
      "livestreamSessionBatch",
      "userLivestreamAuth",
      "isValidSession",
      "userSessionDetail",
      "checkPaymentEnableOrDisable",
    ]),
  },
  methods: {
    ...mapActions([
      "getSessionReviewBatch",
      "userReviewLike",
      "getLivestreamSessionBatch",
      "postUserTipTransfer",
      "postUserLivestreamAuth",
      "validateSession",
      "getUserSessionDetail",
      "userSessionJoin",
      "getCheckPaymentEnableOrDisable",
    ]),

    handleLoginSessionModal(val) {
      this.isLoginSessionModalOpen = val;
    },

    handleSessionJoinModal(val) {
      this.isSessionJoinModalOpen = val;
    },

    handleButtonClick() {
      const paymentSuccessRedirectProps = {
        ...this.paymentSuccessRedirectProps,
        redirectUrl: this.$route.path,
        componentName: "sessionPurchase",
      };
      localStorage.setItem(
        "paymentSuccessRedirectProps",
        JSON.stringify(paymentSuccessRedirectProps)
      );
      this.$router.push({ name: "UserAddMoney" });
    },

    async handleJoinClick() {
      const data = {
        cost: this.batch.cost,
        group_id: this.batch.group_id,
        batch_id: this.batch.id,
        is_private: this.batch.is_private,
        session_id: this.batch.session_id,
      };
      await this.userSessionJoin(data);
      this.isSessionJoinModalOpen = !this.isSessionJoinModalOpen;
      location.reload();
    },

    async handleLoginSuccess() {
      const live_session_id = this.$route.params.id;
      await this.getLivestreamSessionBatch(live_session_id);

      this.batch =
        this.livestreamSessionBatch &&
        this.livestreamSessionBatch.batch &&
        this.livestreamSessionBatch.batch[0];
      
      this.meeting =
        this.livestreamSessionBatch && this.livestreamSessionBatch.meeting;
            
      this.reviews = this.livestreamSessionBatch.reviews;
      this.stores = this.livestreamSessionBatch.stores;
      this.users_joined = this.livestreamSessionBatch.users_joined;
      localStorage.setItem("liveSessionUrl", window.location.href);
      this.handleLoginSessionModal(false);
      await this.getCheckPaymentEnableOrDisable();
      this.checkPaymentEnableOrDisable.forEach((element) => {
        //if value == 0 then payment is disable if value == 1 then payment is enabled
        if (element.key == "tip") {
          if (element.value == "0") this.paymentEnableDisable = "";
          else this.paymentEnableDisable = element.value;
        }
      });
      let request = {
        batch_id: live_session_id,
        user_type: "user", // new key added
      };
      //room size full code refrence
      await this.validateSession(live_session_id);

      //Check if user is already subscribed to the session
      await this.postUserLivestreamAuth(request);
      if (this.userLivestreamAuth.statusCode == 386) {
        this.sessionEndedThumbnailImage = true;
        this.sessionEnded = true;
        //session expired
      } else if (this.userLivestreamAuth.statusCode == 384) {
        // const error = {
        //   title: "INVALID_CREDENTIAL",
        //   text: res.data.message,
        // };
        // store.commit("setError", error);
        //payment not completed
      }
      //If user is not subscribed and also check if room suze is full or not
      else if (this.userLivestreamAuth.statusCode == 388) {
        //subscribed yet then if room size is full then don't show the room_size_full modal
        if (this.isValidSession.statusCode == 392) {
          this.handleLoginSessionModal(false);
          this.roomSizeFull = true;
          return;
        }
        //Not subscribed yet then if room size is full then  show the room_size_full modal
        else {
          // this.isSessionJoinModalOpen = true;
        }
      } else if (
        this.userLivestreamAuth.statusCode == 200 ||
        this.userLivestreamAuth.statusCode == 382
      ) {
        this.isSessionJoinModalOpen = false;
      }

      await this.getSessionReviewBatch(live_session_id);
      //Checking if user has already given review or not
      this.sessionReviewBatch &&
        this.sessionReviewBatch.data.forEach((review) => {
          const user_id = this.getUser() && this.getUser().id;
          if (review.reviewer_id == user_id) {
            this.isSessionReviewBatchShow = false;
          }
        });
      this.handleSessionReviewBatch();
      this.replaceThumbnailWithMessage(this.batch && this.batch.end_date);
      this.isSessionStarted(this.batch && this.batch.start_date);
    },

    async handleReviewId(id) {
      const data = {
        review_id: id,
        review_type: this.REVIEW_TYPE,
        is_liked: this.IS_LIKED,
      };
      await this.userReviewLike(data);
      await this.getSessionReviewBatch(this.$route.params.id);
      this.reviews = this.livestreamSessionBatch.reviews;
    },

    async handleSessionReviewBatch() {
      let arr = [];
      this.sessionReviewBatch &&
        this.sessionReviewBatch.reviews &&
        this.sessionReviewBatch.reviews.map((r) => {
          arr.push(r.reviewer_id);
        });
      if (arr.includes(this.getUser() && this.getUser().id)) {
        this.isSessionReviewBatchShow = true;
      }
    },

    trainerModalOpen() {
      this.isModalOpen = !this.isModalOpen;
    },

    tipTrainerSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("Invalid");
      } else {
        const data = {
          trainer_id: this.batch.trainer_id,
          batch_id: this.$route.params.id,
          credits: this.credits,
          message: this.message,
        };
        if (!this.paymentEnableDisable) {
          alert("Payment feature is disable for now");
        } else {
          if (this.credits > this.wallet_balance) {
            // this.user.wallet.balance
            alert(
              "Insufficent wallent balance. You have " +
                this.wallet_balance +
                " credits in your wallet."
            );
            this.credits = "";
          } else {
            this.postUserTipTransfer(data);
            this.trainerModalOpen();
          }
        }
      }
    },

    async reviewDeleted() {
      this.isSessionReviewBatchShow = true;
      await this.getSessionReviewBatch(this.$route.params.id);
      this.reviews = this.livestreamSessionBatch.reviews;
      this.showEditReview = false;
    },

    handleEditReview(id) {
      this.showEditReview = true;
      this.review_id = id;
    },

    handleSessionFeedbackAllModal(val) {
      this.sessionFeedbackAll = val;
    },

    toggleSessionReview() {
      this.sessionFeedbackAll = true;
    },

    replaceThumbnailWithMessage(endDate) {
      var endTime = new Date(this.convertUTCDateToLocalDate(endDate)).getTime();
      var x = setInterval(() => {
        var currentTime = new Date().getTime();
        if (currentTime >= endTime) {
          this.sessionEnded = true;
          this.sessionEndedThumbnailImage = true;
          clearInterval(x);
        }
      }, 1000);
    },

    isSessionStarted(startDate) {
      var startTime = new Date(
        this.convertUTCDateToLocalDate(startDate)
      ).getTime();
      var x = setInterval(() => {
        var currentTime = new Date().getTime();
        if (currentTime >= startTime) {
          this.sessionStarted = true;
          clearInterval(x);
        }
      }, 1000);
    },

    getSignature() {
      axios
        .post(this.signatureEndpoint, {
          meetingNumber: this.meeting && this.meeting.meeting_id,
          role: 0,
        })
        .then((res) => {
          // console.log(res.data.signature);
          this.startMeeting(res.data.signature);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    startMeeting(signature) {
      document.getElementById("zmmtg-root").style.display = "block";
      ZoomMtg.init({
        leaveUrl: this.leaveUrl,
        success: (success) => {
          // console.log(success);
          ZoomMtg.join({
            meetingNumber: this.meeting && this.meeting.meeting_id,
            userName: this.userEmail,
            signature: signature,
            sdkKey: this.sdkKey,
            userEmail: this.userEmail,
            passWord: this.meeting && this.meeting.meeting_password,
            tk: "", // this.registrantToken
            success: (success) => {
              // console.log(success);

              const mountNode = document.createElement("div");
              mountNode.id = "mount-node";
              document.getElementById("zmmtg-root").appendChild(mountNode);

              var ComponentClass = Vue.extend(TipPaymentModal);
              const dataObj = {
                paymentModal: false,
                stripe: Stripe(window.config.VUE_APP_STRIPE_CLIENT_ID, {
                  stripeAccount:
                    this.session &&
                    this.session.details &&
                    this.session.details.trainer_account_id,
                }),
                stripe1: Stripe(window.config.VUE_APP_STRIPE_CLIENT_ID),
                // The items the customer wants to buy
                elements: {},
                nameOnCard: null,
                amount: 5,
                message: null,
                paymentMethodId: null,
                clientSecret: null,
                isProcessing: false,
                isNewCard: false,
                isUserCard: false,
                userCardList: [],
                cardNumberElement: null,
                cardExpiryElement: null,
                cardCvcElement: null,
                batchId: this.batch.id,
                trainer_account_id:
                  this.session &&
                  this.session.details &&
                  this.session.details.trainer_account_id,
              };
              var instance = new ComponentClass({
                data() {
                  return dataObj;
                },
              });
              instance.$mount("#mount-node");
            },
            error: (error) => {
              console.log(error);
            },
          });
        },
        error: (error) => {
          console.log(error);
        },
      });
    },
  },
  async created() {
    ZoomMtg.setZoomJSLib("https://source.zoom.us/2.9.0/lib", "/av");
    ZoomMtg.preLoadWasm();
    ZoomMtg.prepareWebSDK();
    // ZoomMtg.prepareJssdk();
    // loads language files, also passes any error messages to the ui
    ZoomMtg.i18n.load("en-US");
    ZoomMtg.i18n.reload("en-US");

    this.batch_id = this.$route.params.id;
    if (this.user && this.user.user_type == 0) {
      var url = window.location.href;
      if (!localStorage.getItem("liveSessionUrl")) {
        localStorage.setItem("liveSessionUrl", url);
      } else if (
        localStorage.getItem("liveSessionUrl") &&
        localStorage.getItem("liveSessionUrl") !== window.location.href
      ) {
        Cookies.remove("token");
        localStorage.removeItem("user");
        localStorage.removeItem("liveSessionUrl");
      }
    }

    try {
      await this.validateSession(this.$route.params.id);

      //for sesssion ended
      if (this.isValidSession.statusCode == 386) {
        this.handleLoginSessionModal(false);
        this.sessionEndedThumbnailImage = true;
        this.sessionEnded = true;
        await this.getLivestreamSessionBatch(this.$route.params.id);
        //if sessin ended show user listing and reviews
        this.batch =
          this.livestreamSessionBatch &&
          this.livestreamSessionBatch.batch &&
          this.livestreamSessionBatch.batch[0];

        this.meeting = this.livestreamSessionBatch && this.livestreamSessionBatch.meeting;

        this.reviews = this.livestreamSessionBatch.reviews;
        this.stores = this.livestreamSessionBatch.stores;
        this.users_joined = this.livestreamSessionBatch.users_joined;

        await this.getSessionReviewBatch(this.$route.params.id);
        //Checking if user has already given review or not
        this.sessionReviewBatch &&
          this.sessionReviewBatch.data.forEach((review) => {
            const user_id = this.getUser() && this.getUser().id;
            if (review.reviewer_id == user_id) {
              this.isSessionReviewBatchShow = false;
            }
          });
        this.handleSessionReviewBatch();
        this.isSessionStarted(this.batch && this.batch.start_date);
        return;
      } else if (this.isValidSession.statusCode == 200) {
        await this.getUserSessionDetail(this.isValidSession.data.session_id);
        this.batches = this.userSessionDetail.batches;
        this.session = this.userSessionDetail.session;
        this.wallet_balance = this.userSessionDetail.wallet_balance;

        const batch =
          this.batches.available &&
          this.batches.available.data &&
          this.batches.available.data.filter(
            (b) => b.id === parseInt(this.$route.params.id)
          );
        this.sessionJoinData.batch = batch[0];
      }

      if (this.isValidSession.statusCode != 319 && !this.getToken()) {
        //Not already logged in, show login
        this.isLoginSessionModalOpen = !this.isLoginSessionModalOpen;
        return;
      }
      this.handleLoginSessionModal(false);
      this.handleLoginSuccess();
    } catch (e) {
      console.log(e);
      this.handleLoginSessionModal(false);
      return;
    }
  },
  mounted() {
    ZoomMtg.inMeetingServiceListener("onUserJoin", (data) => {
      // console.log("inMeetingServiceListener onUserJoin", data);
    });
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  destroyed() {
    this.$destroy();
    if (this.user && this.user.user_type == 0) {
      Cookies.remove("token");
      localStorage.removeItem("user");
      localStorage.removeItem("liveSessionUrl");
    }
  },
};
</script>

<style>
#zmmtg-root {
  display: none;
}
</style>